export const SIGNER = "{{signer}}";
export const HEADING = "{{heading}}";
export const CLIENT_INITIAL = "{{clientInitial}}";
export const PAYMENT_COMPONENT = "{{payment_component}}";
export const EVENT_ITINERARY = "{{event_itinerary}}";
export const CONTRACT_TOTAL = "{{contract_total}}";
export const PAGE_BREAK = "{{page_break}}";

export const INITIAL_STATE = `
<p>&nbsp;</p><section class="product" data-id="1"></section><h2><br>1. Event Details</h2><h2>&nbsp;</h2><div class="page" title="Page 1"><div class="layoutArea"><div class="column"><p><span>The scope and extent of the services for the Event(s), as selected by Client, including but not limited to the type of event(s), the venues that have partnered with TPE and meet TPE's standards ("Partner Venues"), the day(s) and time(s), are specified in Attachment "A", attached hereto and incorporated as part of this Agreement.</span><br>&nbsp;</p><div class="page" title="Page 1"><div class="layoutArea"><div class="column"><section class="product" data-id="5"></section><p><br><span>(b) Deposit and Payment: See Attachment "B"</span></p><p><br><span>(c) Cancellation:</span></p><p style="margin-left:40px;"><span>1. Deposit is non-refundable. Cancellation of this Agreement by Client will result in the following balance being due and non-refundable. If payments have been made exceeding the amount due after cancellation,&nbsp;</span><br><span>the remaining balance will be refunded to client within 21 days.</span></p><p style="margin-left:40px;">&nbsp;</p><p style="margin-left:40px;"><span>Cancellation 21+ Days Prior to Event: 25% of total Contract Price is due</span></p><p style="margin-left:40px;">&nbsp;</p><p style="margin-left:40px;"><span>Cancellation 8-20 Days Prior to Event: 50% of total Contract Price is due</span></p><p style="margin-left:40px;">&nbsp;</p><p style="margin-left:40px;"><span>Cancellation 0-7 Days Prior to Event: Total Contract Price is Due. Zero Refund will be awarded.</span></p><p style="margin-left:40px;">&nbsp;</p><p style="margin-left:40px;"><span>If either TPE or the Partner Venue booked pursuant to this Agreement cancel for any reason prior to the Event date, full payment will be refunded to the Client, including the Deposit. If Client must cancel event due to Covid-19 regulations set forth by state law, federal law, or university requirement, any payments made will be held as a credit for future event.</span></p><p style="margin-left:40px;">&nbsp;</p><p style="margin-left:40px;"><span>2. Notwithstanding any other provision of this Agreement, TPE may terminate this Agreement without Notice or further liability to Client if Client fails to make all payments when due. In no event shall TPE or the Partner Venue be liable for any consequential loss or damages alleged to have been caused by said cancellation</span></p><div class="page" title="Page 1"><div class="layoutArea"><div class="column"><p>&nbsp;</p><p><span>(d) Food &amp; Beverage minimums listed are not included in the Contract Price. Additional fees, costs (including, but not limited to, damage or cleanup as described in Attachment "A") shall be invoiced to Client and shall be due within fifteen (15) days of receipt by Client.</span></p><p>&nbsp;</p><p><span>(e) Service Charge: Client agrees to pay an initial service charge of 10% for any past due payments and 1.5% for each month thereafter until paid in full.</span></p><p>&nbsp;</p><p><span>(f) Collection: Should Client fail to pay any payment when due, Client shall pay all reasonable court costs, inves- tigation fees, and attorneys' fees and costs as well as all other costs of collection incurred by TPE in collecting any past due amount from Client.</span></p></div></div></div><p>&nbsp;</p><div class="page" title="Page 1"><div class="layoutArea"><div class="column"><h2>3. Insurance And Indemnity</h2></div></div></div><p>&nbsp;</p><div class="page" title="Page 1"><div class="layoutArea"><div class="column"><p><span>(a) TPE represents and warrants that it carries Workers' Compensation insurance and General Liability insurance, to the extent required by law.</span></p><div class="page" title="Page 2"><div class="layoutArea"><div class="column"><p><br><span>(b) Client shall defend, indemnify and hold harmless TPE, its agents and employees from or against any claim, loss (including but not limited to, fire, theft, or other casualty or loss), damage, injury, judgment, liability, lien or cause of action, including reasonable attorney's fees and/or costs, for injury to person or property, or death of a person (collectively hereinafter "Claims"), arising from, or alleged to have arisen from, the active or passive negligence, concurrent or otherwise, or willful misconduct of Client, its employees, Event guests, associates or agents, in connection with the Event, the Event venue, or TPE's performance of its services hereunder, or for any defect on the venue premises, or for any services not specified herein or in Attachment "A" and performed by TPE at the request, direction, or on behalf of Client.</span></p><p><br><span>(c) Subject to the preceding paragraph, TPE shall defend, indemnify and hold harmless Client, its agents and employees from or against any claim, loss (including but not limited to, fire, theft, or other casualty or loss), damage, injury, judgment, liability, lien or cause of action, including reasonable attorney's fees and/or costs, for injury to person or property, or death of a person (collectively hereinafter "Claims"), but only to the extent that such Claims are determined to have arisen out of the performance of services under this Agreement, and were caused by the sole negligence or willful misconduct of TPE, its employees or agents while TPE, its employees or agents were acting within the course and scope of their duties and authority under this Agreement. In no event shall TPE be liable for any Claims caused in whole or in part by the active or passive negligence or willful misconduct of Client, any Event guests, associates or agents of Client, or by any defect on the venue premise. In no event shall TPE be liable for any punitive, exemplary, consequential or incidental damages or loss of profits</span></p><p><br><span>(d) Notwithstanding anything to the contrary herein, in no event shall TPE indemnify or hold harmless Client for any Claims resulting from any injury or death sustained by any employee of TPE, and TPE's indemnity obligations set forth in this Section shall not be construed as a waiver of the statutory protections afforded to TPE by any and all applicable Worker's Compensation laws or statutes.</span></p><p><br><span>(e) The indemnity obligations of TPE and Client set forth herein shall survive the expiration or termination of this Agreement.</span></p><p><br><span>(f) In no event shall TPE be liable for Claims resulting from, or alleged to be resulting from, the use or presence of alcohol or controlled substances, or the use of false identification by Client, Event guests or associates of Client.</span><br>&nbsp;</p><h2>4. Independent Contractors<br>&nbsp;</h2><p><span>(a) TPE agrees to perform the services described in this Agreement as an independent contractor and not as an employee, agent, or associate of Client.</span></p><p><br><span>(b) TPE shall hire all Event personnel and may change Event personnel at will. Upon reasonable request by Client, TPE shall reassign its employees as long as such request does not violate any applicable state or federal law. TPE shall be responsible for the payment of all its employees' wages, appropriate expenses, and employer's contribution to all applicable taxes.</span></p><p><br><span>(c) TPE shall have the right to contract with third party vendors and subcontractors, in order to provide the necessary services, unless otherwise mutually agreed upon by the Parties in writing. In no event will TPE be responsible for any of the actions, active or passive negligence, or willful misconduct of the third party vendors or subcontractors, their employees or agents, in connection with the Event, the Event venue, or TPE's performance of its services hereunder, or for any services not specified herein or in Attachment "A" and performed by TPE at the request, direction, or on behalf of Client.</span><br>&nbsp;</p><h2>5. Confidentiality<br>&nbsp;</h2><p><span>TPE's research, business plan, development of services and products, customer lists, vendor lists, finances, and trade secrets are confidential information and Client agrees not to disclose such confidential information or infor- mation relating thereto to any person, firm corporation or any other entity. The release of any such information to any person shall be deemed to be a violation of this Agreement</span><br><span>.</span></p><h2>6. Force Majeure</h2><p><br><span>The obligations of TPE herein may be suspended during any period where performance is prevented by acts of God, nature, civil or labor disturbance, or events beyond TPE's reasonable economic control.</span><br>&nbsp;</p><h2>7. No Warranty<br>&nbsp;</h2><p><span>Client recognizes that TPE is not an insurer of property or persons and makes no warranty, express or implied, that the services provided will prevent loss, damage or injury to Client's guests, invitees, employees, or property, or from injury or death of any person or the consequences therefrom.</span></p><h2><br>8. Waiver<br>&nbsp;</h2><div class="page" title="Page 3"><div class="layoutArea"><div class="column"><p><span style="font-family:'Helvetica';font-size:9.000000pt;">The failure of any party at any time or times to require performance of any provision hereof shall in no manner affect the right at a later time to enforce the same or any other provision of this Agreement.</span><br>&nbsp;</p><h2>9. Entire Agreement</h2><p>&nbsp;</p></div></div></div><div class="page" title="Page 3"><div class="layoutArea"><div class="column"><p><span>This Agreement sets forth the entire agreement and understanding of the Parties in respect of the transactions contemplated hereby and supersedes all prior and contemporaneous negotiations, promises, covenants, agree- ments, representations, arrangements, undertakings and understandings relating to the subject matter hereof. No representation, promise, inducement or statement of intention has been made which is not embodied in this Agreement and its Attachments. None of the Parties shall be bound by or be held liable for any alleged represen- tation, promise, inducement or statement not set forth herein.</span></p><p>&nbsp;</p><h2>10. Representative Capacity</h2><p>&nbsp;</p><p><span>Each party who signs this Agreement in a representative capacity represents and warrants that he or she is authorized to execute the Agreement on behalf of the person or entity on whose behalf his or her signature is affixed.</span></p><p>&nbsp;</p><h2>11. California Law</h2><p>&nbsp;</p><p><span>This Agreement is entered into in California. The Parties expressly agree that the Agreement shall be governed by, interpreted, construed and enforced in accordance with the domestic laws of the State of California without regard to principles of conflicts law.</span><br>&nbsp;</p><h2>12. Interpretation Of Agreement</h2><p>&nbsp;</p><p><span>The language of this Agreement shall be interpreted as a whole, according to its fair meaning, and not strictly for or against any of the Parties, regardless of which is the drafter of this Agreement.</span></p><p>&nbsp;</p><h2>13. Amendment/Mofication</h2><p>&nbsp;</p><p><span>This Agreement may only be amended, modified, or superseded in writing executed by each of the Parties.</span></p><p>&nbsp;</p><h2>14. Attorney Fees</h2><p>&nbsp;</p><p><span>In the event legal action or proceeding is necessary or appropriate to enforce or construe a provision of the Agreement, or to seek relief for breach thereof, the prevailing party in such action or proceeding shall be entitled to recover the reasonable costs incurred, including reasonable attorney fees.</span></p><p>&nbsp;</p><h2>15. No Third Party Rights</h2><p>&nbsp;</p><p><span>Nothing in this Agreement is intended to confer any rights or remedies on anyone other than the Parties to the Agreement and their respective successors, representatives and assigns. The provisions of this Agreement shall not entitle any person not a signatory to this Agreement to any rights as a third party beneficiary, or otherwise, it being the specific intention of the Parties hereto to preclude any and all non-signatory Parties from any such third party beneficiary rights, or any other rights whatsoever.</span><br>&nbsp;</p><div class="page" title="Page 3"><div class="layoutArea"><div class="column"><p style="text-align:center;"><span><strong>THIS AGREEMENT, INCLUDING ALL ATTACHMENTS, MAY BE EXECUTED IN COUNTERPARTS AND A FACSIMILE OR ELECTRONIC SIGNATURE PAGE WILL HAVE THE SAME FORCE AND AFFECT AS THE ORIGINAL SIGNATURE PAGE</strong></span><br><br>&nbsp;</p><div class="page" title="Page 3"><div class="layoutArea"><div class="column"><p style="text-align:center;"><span><strong>IN WITNESS HEREOF, Parties have executed this contract as of the day, month and year indicated above.</strong></span></p><section class="product" data-id="6"></section><p style="text-align:center;"><br><br>&nbsp;</p><div class="page-break" style="page-break-after:always;"><span style="display:none;">&nbsp;</span></div><p style="text-align:center;"><span class="text-big"><strong><u>ATTACHMENT “A”</u></strong></span></p><div class="page" title="Page 4"><div class="layoutArea"><div class="column"><p style="text-align:center;"><br>&nbsp;</p><div class="page" title="Page 4"><div class="layoutArea"><div class="column"><p>&nbsp;</p><h2>Scope of Work</h2><p>&nbsp;</p><p><span>TPE, in consideration for payment as set forth in Paragraph 2 of Page 1 of this Agreement, will provide one or more of the following services. Each service being provided will be detailed in each of the "Event Itinerary" pages following "Attachment B". Some services may not be provided and as such the corresponding scope of work for that particular service is not relevant.</span></p><p>&nbsp;</p><h2>Venue Selection &amp; Catering</h2><p>&nbsp;</p><p><span>TPE will work with Client to select a venue for the Event among venues that have partnered with TPE and meet TPE's standards ("Partner Venues").</span></p><p>&nbsp;</p><h2>On-Site Event Staff &amp; Security</h2><p>&nbsp;</p><p><span>TPE will monitor the event to reasonably ensure that only invited guests are permitted into the Event. If applica- ble, event staff shall require identification to verify guests are of legal drinking age, and shall supply identifying wristbands where necessary.</span></p><p>&nbsp;</p><p><span>TPE shall determine when registered security officers are required. In such cases, all such employees shall be properly licensed pursuant to the requirements of the State of California.</span></p><p>&nbsp;</p><h2>Entertainment: DJ, Karaoke, and/or Performing Artist(s)</h2><p>&nbsp;</p><p><span>TPE will provide Entertainment services upon the request of the client as documented in this agreement. DJs and Performing Artists may have additional requirements to fulfill known as "Artist Riders". Artist Riders are not included in this agreement and are the sole responsibility of the client to fulfill. Artist Riders will be provided by TPE prior to the event.</span></p><p>&nbsp;</p><p><span>Failure of any equipment or power supply shall not be the responsibility of TPE. Should any TPE or Partner Venue equipment be damaged as a result of any act or omission of Client, Event guests or associates of Client, Client agrees to reimburse the reasonable costs to repair or replace said equipment in the reasonable discretion of TPE. Client is to ensure that all guests are notified and informed not to move, climb upon, or otherwise touch any equipment provided by TPE.</span></p><p>&nbsp;</p><h2>Transportation</h2><p>&nbsp;</p><p><span>Transportation services shall be limited to the pick-up, transport, and drop off for guests at locations and times as specified in this agreement.</span></p><p>&nbsp;</p><p><span>TPE reserves the right to contract with American Transportation Systems &amp; American Transportation Sightseeing ("ATS"), or any other third-party vendor, for the requested transportation services pursuant to this Agreement.</span></p><p><span>TPE reserves the right to charge, and Client agrees to pay, reasonable clean-up fees for excessive soil of (including vomit), or damage to, any vehicle used pursuant to this Agreement if caused by any act or omission of Client, associates of Client or Event guests, as follows:</span></p><p>&nbsp;</p><p><span>1. $150.00 cleaning fee for each school bus which requires excessive cleaning during or immediately following the Event, as determined by TPE;</span></p><p>&nbsp;</p><p><span>2. $200.00 cleaning fee for each charter bus which requires excessive cleaning during or immediately following the Event, as determined by TPE;</span></p><p>&nbsp;</p><p><span>3. $250.00 cleaning fee for each limousine bus which requires excessive cleaning during or immediately following the Event, as determined by TPE;</span></p><p>&nbsp;</p><p><span>4. $150.00 penalty for each incident of smoking on a transportation vehicle;</span></p><p>&nbsp;</p><p><span>5. The cost of repair for all other damage to the transportation vehicles during or immediately following the Event.</span></p><p>&nbsp;</p><p><span>6. A $500 cleaning fee will be assessed for any cleaning fee involving urine or feces.</span></p><p>&nbsp;</p><p><span>All such costs invoiced to Client and shall be due within fifteen (15) days of receipt by Client.</span><br>&nbsp;</p><div class="page" title="Page 5"><div class="layoutArea"><div class="column"><p><span>Smoking and/or Vaping of any kind on the vehicles is prohibited. Overcrowding of vehicles and drinking of alcohol by minors is strictly prohibited (Vehicle Code § 23224).</span></p><p>&nbsp;</p><p><span>TPE and its appointed operators or drivers reserves the right to cancel the transportation services at any time for the safety of the drivers, the guests, or for the safe operation of the vehicles.</span></p><p>&nbsp;</p><h2>Audio/Visual</h2><p>&nbsp;</p><p><span>TPE will set up and/or operate requested audio, lighting, or staging equipment.</span></p><p>&nbsp;</p><p><span>Failure of any equipment or power supply shall not be the responsibility of TPE. Should any TPE or Partner Venue equipment be damaged as a result of any act or omission of Client, Event guests or associates of Client, Client agrees to reimburse the reasonable costs to repair or replace said equipment in the reasonable discretion of TPE. Client is to ensure that all guests are notified and informed not to move, climb upon, or otherwise touch any equipment provided by TPE.</span></p><p>&nbsp;</p><h2>Media: Photographer, Videographer, and/or Photobooth</h2><p>&nbsp;</p><p><span>TPE will provide a photographer and/or videographer for a minimum of one hour, unless otherwise agreed upon by the Parties in writing. All photographs/videos taken will be available to Client via TPE's website. Client may request password only access to the photos to keep viewing private. Videos of the event may take up to 21 days to become available for viewing. Photographs and videos may be removed from the website upon email request by Client to TPE.ailure of any equipment or power supply shall not be the responsibility of TPE. Should any TPE or Partner Venue equipment be damaged as a result of any act or omission of Client, Event guests or associates of Client, Client agrees to reimburse the reasonable costs to repair or replace said equipment in the reasonable discretion of TPE. Client is to ensure that all guests are notified and informed not to move, climb upon, or otherwise touch any equipment provided by TPE.</span></p><p>&nbsp;</p><p><span>All photographs and videos shall be the property of TPE and TPE retains all rights, title and interest in any and all photographs, video, or other depiction of the Event and all Event guests if taken by its agents, subcontractors or employees for the Event pursuant to this Agreement.</span></p><p>&nbsp;</p><h2>Other Services</h2><p>&nbsp;</p><p><span>As stated in each individual "Event Itinerary".</span><br><br>&nbsp;</p><div class="page" title="Page 5"><div class="layoutArea"><div class="column"><p style="text-align:center;"><span><strong>ALL SERVICES PROVIDED BY TPE SHALL BE DEEMED SATISFACTORY UNLESS TPE RECEIVES WRITTEN NOTICE WITHIN TEN (10) DAYS OF THE DATE OF PERFORMANCE PURSUANT TO THIS AGREEMENT.</strong></span></p><p style="text-align:center;">&nbsp;</p><section class="product" data-id="3"></section><p style="text-align:center;"><br>&nbsp;</p><div class="page-break" style="page-break-after:always;"><span style="display:none;">&nbsp;</span></div><p>&nbsp;</p><section class="product" data-id="2"></section><div class="page-break" style="page-break-after:always;"><span style="display:none;">&nbsp;</span></div><section class="product" data-id="4"></section><p>&nbsp;</p></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div>
`;


export const TEMPLATE_DEMO_STATE_OBJECT = {
  id: 1019,
  guestCount: 200,
  startDate: "2023-10-20",
  startTime: "22:00:00",
  endTime: "01:00:00",
  isTPEBooked: true,
  isClientBooked: true,
  whatsTheDeal: "Test value deal",
  pickUpTime: "21:30:00",
  dropOffTime: "01:30:00",
  clientBudget: "10000.00",
  totalCost: "9500.00",
  profit: "500.00",
  profitMargin: 0.05,
  totalCap: 500,
  clientResponsibility: "Test client responsibility",
  tpeResponsibility: "Test TPE responsibility",
  finalBarSales: "Test bar sales",
  finalBarSalesDescription: "Test bar sales description",
  title: "Test Event Title",
  barGuarantee: "5000.00",
  tpeGamble: "1000.00",
  contractStatus: "Test contract status",
  signDate: "2023-09-22",
  calendar: "Test calendar",
  pdfContract: "Test PDF contract",
  isPhantom: true,
  isInvoiced: true,
  documentId: 1234,
  totalPostExpenses: "1000",
  transactionId: 5678,
  shouldConsiderClientResponsibility: true,
  createdAt: "2023-09-05",
  updatedAt: "2024-03-28T04:17:49.157Z",
  deletedAt: null,
  parentEvent: "Test parent event",
  pickNDrops: [
    {
      id: 471,
      type: "pickUp",
      location: "Test main pickup location",
    },
    {
      id: 1203,
      type: "dropOff",
      location: "Test main dropoff location",
    },
  ],
  clientType: {
    id: 6,
    name: "COLLEGE",
  },
  venue: {
    id: 444,
    name: "Test Venue",
  },
  eventType: {
    id: 24,
    name: "Test Event Type",
  },
  region: {
    id: 1,
    name: "LA",
  },
  soldBy: {
    id: 17,
    firstName: "Olivia",
    lastName: "Simpson",
  },
  createdBy: {
    id: 17,
    firstName: "Olivia",
    lastName: "Simpson",
  },
  eventClients: [
    {
      id: 1108,
      isSigner: true,
      createdAt: "2023-09-06T02:47:45.508Z",
      collaborator: {
        id: 3,
        name: "Test Collaborator",
      },
      client: {
        id: 17,
        name: "SIGMA NU",
        email: "test@example.com",
      },
    },
  ],
  staffBillings: [
    {
      id: 16357,
      quantity: 2,
      charges: "200",
      shouldShowOnContract: true,
      staffType: "Event Assistant",
      createdAt: "2023-09-06T02:47:39.740Z",
      serviceType: {
        id: 5,
        name: "Coordination",
      },
    },
    {
      id: 16358,
      quantity: 3,
      charges: "468",
      shouldShowOnContract: true,
      staffType: "Security Manager",
      createdAt: "2023-09-06T02:47:39.740Z",
      serviceType: {
        id: 2,
        name: "Security",
      },
    },
    {
      id: 16359,
      quantity: 4,
      charges: "528",
      shouldShowOnContract: true,
      staffType: "Security Guard",
      createdAt: "2023-09-06T02:47:39.740Z",
      serviceType: {
        id: 2,
        name: "Security",
      },
    },
    {
      id: 16360,
      quantity: 1,
      charges: "275",
      shouldShowOnContract: true,
      staffType: "DJ",
      createdAt: "2023-09-06T02:47:39.740Z",
      serviceType: {
        id: 6,
        name: "Entertainment",
      },
    },
    {
      id: 16361,
      quantity: 1,
      charges: "325",
      shouldShowOnContract: true,
      staffType: "DJ+Karaoke",
      createdAt: "2023-09-06T02:47:39.740Z",
      serviceType: {
        id: 6,
        name: "Entertainment",
      },
    },
    {
      id: 16362,
      quantity: 1,
      charges: "275",
      shouldShowOnContract: true,
      staffType: "Karaoke",
      createdAt: "2023-09-06T02:47:39.740Z",
      serviceType: {
        id: 6,
        name: "Entertainment",
      },
    },
    {
      id: 16363,
      quantity: 1,
      charges: "500",
      shouldShowOnContract: true,
      staffType: "Band",
      createdAt: "2023-09-06T02:47:39.740Z",
      serviceType: {
        id: 6,
        name: "Entertainment",
      },
    },
    {
      id: 16364,
      quantity: 1,
      charges: "150",
      shouldShowOnContract: true,
      staffType: "Photographer",
      createdAt: "2023-09-06T02:47:39.740Z",
      serviceType: {
        id: 5,
        name: "Coordination",
      },
    },
    {
      id: 16365,
      quantity: 1,
      charges: "100",
      shouldShowOnContract: true,
      staffType: "Photo Booth",
      createdAt: "2023-09-06T02:47:39.740Z",
      serviceType: {
        id: 5,
        name: "Coordination",
      },
    },
  ],
  productionBillings: [
    {
      id: 98,
      quantity: 13,
      charges: "10",
      equipmentType: "Par Can",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 3,
        name: "Lighting",
      },
    },
    {
      id: 194,
      quantity: 1,
      charges: "200",
      equipmentType: "Red Carpet",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 6,
        name: "Aux",
      },
    },
    {
      id: 246,
      quantity: null,
      charges: "2000",
      equipmentType: "Video Wall",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 3,
        name: "Lighting",
      },
    },
    {
      id: 251,
      quantity: null,
      charges: "75",
      equipmentType: "Haze Machine",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 6,
        name: "Aux",
      },
    },
    {
      id: 393,
      quantity: null,
      charges: "250",
      equipmentType: "Confetti Cannon",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 6,
        name: "Aux",
      },
    },
    {
      id: 511,
      quantity: null,
      charges: "200",
      equipmentType: "CO2 Cannon",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 6,
        name: "Aux",
      },
    },
    {
      id: 536,
      quantity: null,
      charges: "150",
      equipmentType: "Speaker (Concert)",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 1,
        name: "Sound",
      },
    },
    {
      id: 648,
      quantity: null,
      charges: "100",
      equipmentType: "Screen",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 3,
        name: "Lighting",
      },
    },
    {
      id: 734,
      quantity: null,
      charges: "100",
      equipmentType: "Moving Head",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 3,
        name: "Lighting",
      },
    },
    {
      id: 753,
      quantity: null,
      charges: "250",
      equipmentType: "Subwoofer/Bass (Concert)",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 1,
        name: "Sound",
      },
    },
    {
      id: 973,
      quantity: null,
      charges: "100",
      equipmentType: "Laser",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 3,
        name: "Lighting",
      },
    },
    {
      id: 1345,
      quantity: null,
      charges: "150",
      equipmentType: "Custom Gobo",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 6,
        name: "Aux",
      },
    },
    {
      id: 1394,
      quantity: null,
      charges: "500",
      equipmentType: "Small Truss",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 2,
        name: "Structure",
      },
    },
    {
      id: 1403,
      quantity: null,
      charges: "250",
      equipmentType: "Scissor Lift",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 5,
        name: "Transport",
      },
    },
    {
      id: 1487,
      quantity: null,
      charges: "75",
      equipmentType: "Stage Piece (3x6)",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 4,
        name: "Staging",
      },
    },
    {
      id: 1608,
      quantity: null,
      charges: "150",
      equipmentType: "Medium Truck",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 5,
        name: "Transport",
      },
    },
    {
      id: 8010,
      quantity: null,
      charges: "225",
      equipmentType: "Big Truck",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 5,
        name: "Transport",
      },
    },
    {
      id: 8084,
      quantity: null,
      charges: "1000",
      equipmentType: "Medium Truss",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 2,
        name: "Structure",
      },
    },
    {
      id: 8114,
      quantity: null,
      charges: "100",
      equipmentType: "CO2 Tank Add On",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 6,
        name: "Aux",
      },
    },
    {
      id: 8184,
      quantity: null,
      charges: "75",
      equipmentType: "Popcorn/Cotton Candy",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 6,
        name: "Aux",
      },
    },
    {
      id: 8309,
      quantity: null,
      charges: "10",
      equipmentType: "Backlight",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 3,
        name: "Lighting",
      },
    },
    {
      id: 8399,
      quantity: null,
      charges: "35",
      equipmentType: "Speaker (Basic)",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 1,
        name: "Sound",
      },
    },
    {
      id: 8410,
      quantity: null,
      charges: "1500",
      equipmentType: "Large Truss",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 2,
        name: "Structure",
      },
    },
    {
      id: 8509,
      quantity: null,
      charges: "175",
      equipmentType: "Projector",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 3,
        name: "Lighting",
      },
    },
    {
      id: 8585,
      quantity: null,
      charges: "75",
      equipmentType: "Dance Floor Piece (3x3)",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 4,
        name: "Staging",
      },
    },
    {
      id: 8669,
      quantity: null,
      charges: "100",
      equipmentType: "Van",
      createdAt: "2023-07-25T19:31:37.938Z",
      productionType: {
        id: 5,
        name: "Transport",
      },
    },
  ],
  transportationBillings: [
    {
      id: 652,
      quantity: 1,
      charges: "12",
      capacity: 50,
      overtime: "1",
      shuttle: "1",
      shuttleRate: "100",
      transportCompany: "ATS",
      createdAt: "2023-07-25T19:31:37.938Z",
      transportationType: {
        id: 7,
        name: "ATS",
      },
    },
    {
      id: 1107,
      quantity: null,
      charges: null,
      capacity: null,
      overtime: null,
      shuttle: null,
      shuttleRate: "100",
      transportCompany: "",
      createdAt: "2023-07-25T19:31:37.938Z",
      transportationType: null,
    },
    {
      id: 1146,
      quantity: null,
      charges: null,
      capacity: null,
      overtime: null,
      shuttle: null,
      shuttleRate: "100",
      transportCompany: "",
      createdAt: "2023-07-25T19:31:37.938Z",
      transportationType: null,
    },
    {
      id: 1436,
      quantity: null,
      charges: null,
      capacity: null,
      overtime: null,
      shuttle: null,
      shuttleRate: "100",
      transportCompany: "",
      createdAt: "2023-07-25T19:31:37.938Z",
      transportationType: null,
    },
  ],
  expenses: [
    {
      id: 815,
      description: null,
      cost: null,
      shouldShowOnContract: false,
      expenseHead: "Bar Tab",
      createdAt: "2023-07-25T19:31:37.938Z",
      expenseType: {
        id: 1,
        name: "Beverage",
      },
    },
    {
      id: 996,
      description: null,
      cost: null,
      shouldShowOnContract: false,
      expenseHead: "Client Drinks",
      createdAt: "2023-07-25T19:31:37.938Z",
      expenseType: {
        id: 1,
        name: "Beverage",
      },
    },
    {
      id: 1946,
      description:
        "PO #5907Catering | Food and Beverage: Dinner Buffet: House Bread and Butter Baby Mixed Green Salad w/ Balsamic Rosemary Chicken Breast Vegetarian Pasta Garlic Mashed Potatoes Dessert Bar: Assortment of Cookies, Brownies, Mini Cheesecake",
      cost: "7300",
      shouldShowOnContract: true,
      expenseHead: "Dinner",
      createdAt: "2023-07-25T19:31:37.938Z",
      expenseType: {
        id: 2,
        name: "Food",
      },
    },
    {
      id: 2065,
      description: null,
      cost: null,
      shouldShowOnContract: true,
      expenseHead: "Appetizers",
      createdAt: "2023-07-25T19:31:37.938Z",
      expenseType: {
        id: 2,
        name: "Food",
      },
    },
    {
      id: 3716,
      description: "Booking Deposit Due: Within 5 Days of Contract",
      cost: "5485",
      shouldShowOnContract: true,
      expenseHead: "Other",
      createdAt: "2023-07-25T19:31:37.938Z",
      expenseType: {
        id: 3,
        name: "Misc",
      },
    },
    {
      id: 3925,
      description: null,
      cost: null,
      shouldShowOnContract: false,
      expenseHead: "Rental",
      createdAt: "2023-07-25T19:31:37.938Z",
      expenseType: {
        id: 3,
        name: "Misc",
      },
    },
    {
      id: 4011,
      description: null,
      cost: null,
      shouldShowOnContract: false,
      expenseHead: "Staff",
      createdAt: "2023-07-25T19:31:37.938Z",
      expenseType: {
        id: 3,
        name: "Misc",
      },
    },
    {
      id: 4018,
      description: "Booking Deposit Due: Within 30 Days of Contract PO #2752",
      cost: "5485",
      shouldShowOnContract: true,
      expenseHead: "Other",
      createdAt: "2023-07-25T19:31:37.938Z",
      expenseType: {
        id: 3,
        name: "Misc",
      },
    },
    {
      id: 4090,
      description: null,
      cost: null,
      shouldShowOnContract: false,
      expenseHead: "Cleaning",
      createdAt: "2023-07-25T19:31:37.938Z",
      expenseType: {
        id: 3,
        name: "Misc",
      },
    },
    {
      id: 4239,
      description: "Final Payment Due PO #5680",
      cost: "13090",
      shouldShowOnContract: true,
      expenseHead: "Other",
      createdAt: "2023-07-25T19:31:37.938Z",
      expenseType: {
        id: 3,
        name: "Misc",
      },
    },
    {
      id: 10158,
      description: "Beverage Service #5681",
      cost: "2190",
      shouldShowOnContract: false,
      expenseHead: "Other",
      createdAt: "2024-03-14T01:14:47.401Z",
      expenseType: {
        id: 3,
        name: "Misc",
      },
    },
  ],
  postEventExpenses: [
    {
      id: 883,
      type: null,
      description: null,
      cost: "0",
      quantity: 0,
    },
  ],
  payments: [
    {
      id: 480,
      payerName: "3NOTRE DAME ACADEMY HIGH SCHOOL",
      dueDate: "03/04/2024",
      amount: "33235",
      isRefundable: false,
      description: null,
      isPaid: false,
      paymentDate: null,
      createdAt: "2023-07-25T19:31:37.938Z",
    },
    {
      id: 611,
      payerName: "ALANNA LOYD",
      dueDate: "04/27/2024",
      amount: "1374012",
      isRefundable: false,
      description: null,
      isPaid: false,
      paymentDate: null,
      createdAt: "2023-07-25T19:31:37.938Z",
    },
  ],
};